import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const Dashboard = (props: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 18 18"
    {...props}
    sx={{ fill: 'none', ...(props.sx || {}) }}
  >
    <path
      d="M1 1H7.22222V7.22222H1V1Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7773 1H16.9996V7.22222H10.7773V1Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7773 10.7773H16.9996V16.9996H10.7773V10.7773Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 10.7773H7.22222V16.9996H1V10.7773Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
